import { render, staticRenderFns } from "./IconGarbageBin.vue?vue&type=template&id=bb7b9900&scoped=true"
import script from "./IconGarbageBin.vue?vue&type=script&lang=js"
export * from "./IconGarbageBin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb7b9900",
  null
  
)

export default component.exports